(function () {
  'use strict';

  /* ===== 리다이렉트 규칙 =====
   * name      : 구분용 이름 (콘솔 로그에만 사용)
   * startAt   : 리다이렉트 시작 시각 (KST, +09:00)
   * endAt     : 리다이렉트 종료 시각 (null = 스크립트 삭제 전까지 계속)
   * from      : 리다이렉트가 필요한 주소 (경로, 여러 개 가능)
   * to        : 이동할 주소 (경로 '/collections/xxx' 또는 전체 URL 'https://...')
   * keepQuery : (선택) 현재 URL의 쿼리(utm 등)를 이동할 주소에 유지할지 여부
   *             true = 유지 / false = 버림 / 생략 = OPTIONS.keepQuery 따름
   */
  var RULES = [
    {
      name: '감사제 티징 → 감사제',
      startAt: '2026-10-29T13:00:00+09:00',
      endAt: '2026-11-05T00:59:00+09:00',
      from: ['/collections/26fw-big-sale-teasing'],
      to: '/collections/26fw-big-sale',
      keepQuery: true
    },
    {
      name: '감사제 종료 → 홈',
      startAt: '2026-11-05T00:59:00+09:00',
      endAt: null,
      from: [
        '/collections/26fw-big-sale-teasing',
        '/collections/firstbuy',
        '/collections/26fw-big-sale',
        '/pages/26fw-big-sale-faq'
      ],
      to: '/',
      keepQuery: false
    }
  ];

  var OPTIONS = {
    // 규칙에 keepQuery를 적지 않았을 때의 기본값
    keepQuery: true,

    // 서버 시간으로 보정할지 여부 (방문자 PC 시계가 틀려도 정확하게 동작)
    useServerTime: true,

    // 테스트용 쿼리 파라미터 (시각과 관계없이 현재 주소에 맞는 규칙으로 이동)
    // ?redirect_test=0  → 즉시 이동
    // ?redirect_test=10 → 10초 뒤 이동
    testParam: 'redirect_test'
  };
  /* ========================== */

  // Shopify 테마 에디터에서는 실행하지 않음
  if (window.Shopify && window.Shopify.designMode) return;

  var LOG = '[redirect]';
  var params = new URLSearchParams(location.search);
  var testValue = params.get(OPTIONS.testParam);
  var isTest = testValue !== null;

  function normalize(path) {
    return (path.replace(/\/+$/, '') || '/').toLowerCase();
  }

  function isAbsolute(url) {
    return /^https?:\/\//i.test(url);
  }

  // 언어 경로 (/, /en/ 등)
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var rootPrefix = root.replace(/\/+$/, ''); // '/' → '', '/en/' → '/en'

  function stripRoot(path) {
    var p = normalize(path);
    if (rootPrefix && p.indexOf(rootPrefix.toLowerCase() + '/') === 0) {
      p = normalize(p.slice(rootPrefix.length));
    }
    return p;
  }

  var currentPath = stripRoot(location.pathname);

  // 이동할 주소의 경로 (같은 도메인일 때만, 다른 도메인이면 null)
  function targetPathOf(rule) {
    if (!isAbsolute(rule.to)) return normalize(rule.to);
    var u = new URL(rule.to);
    if (u.host !== location.host) return null;
    return stripRoot(u.pathname);
  }

  // 현재 주소에 해당하는 규칙만 추림
  var candidates = RULES.filter(function (rule) {
    var matched = rule.from.some(function (p) {
      return normalize(p) === currentPath;
    });
    if (!matched) return false;
    // 이동할 주소가 현재 주소와 같으면 제외 (무한 리다이렉트 방지)
    return targetPathOf(rule) !== currentPath;
  }).map(function (rule) {
    return {
      rule: rule,
      start: new Date(rule.startAt).getTime(),
      end: rule.endAt ? new Date(rule.endAt).getTime() : null
    };
  });

  if (!candidates.length) return;

  // 규칙별 keepQuery (생략 시 OPTIONS 기본값)
  function shouldKeepQuery(rule) {
    return typeof rule.keepQuery === 'boolean' ? rule.keepQuery : OPTIONS.keepQuery;
  }

  function buildTargetUrl(rule) {
    var u = isAbsolute(rule.to)
      ? new URL(rule.to)
      : new URL(location.origin + rootPrefix + rule.to);

    if (shouldKeepQuery(rule)) {
      var q = new URLSearchParams(location.search);
      q.delete(OPTIONS.testParam); // 테스트 파라미터는 넘기지 않음
      q.forEach(function (value, key) {
        if (!u.searchParams.has(key)) u.searchParams.set(key, value);
      });
    }
    return u.toString();
  }

  function redirect(item) {
    var url = buildTargetUrl(item.rule);
    console.log(LOG, '"' + item.rule.name + '" 이동 → ' + url);
    location.replace(url);
  }

  // 지금 적용 중인 규칙 (여러 개면 RULES에서 먼저 적은 규칙 우선)
  function findActive(now) {
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      if (now >= c.start && (!c.end || now < c.end)) return c;
    }
    return null;
  }

  // 가장 먼저 시작될 규칙
  function findNext(now) {
    var next = null;
    candidates.forEach(function (c) {
      if (c.start > now && (!c.end || c.end > c.start)) {
        if (!next || c.start < next.start) next = c;
      }
    });
    return next;
  }

  // 테스트 모드: 시각을 무시하고 지정한 초 뒤에 이동
  if (isTest) {
    var now0 = Date.now();
    var testItem = findActive(now0) || findNext(now0) || candidates[0];
    var delay = Math.max(0, parseInt(testValue, 10) || 0);
    console.log(LOG, '[test] "' + testItem.rule.name + '" ' + delay + '초 뒤 이동 → ' + buildTargetUrl(testItem.rule));
    setTimeout(function () { redirect(testItem); }, delay * 1000);
    return;
  }

  function schedule(offset) {
    var now = Date.now() + offset;

    var active = findActive(now);
    if (active) {
      redirect(active);
      return;
    }

    // 페이지를 열어둔 채로 다음 규칙의 시작 시각이 되면 다시 판단
    var next = findNext(now);
    if (!next) return;

    var wait = next.start - now;
    if (wait < 2147483647) { // setTimeout 최대치(약 24.8일) 이내일 때만
      setTimeout(function () { schedule(offset); }, wait);
    }
  }

  if (!OPTIONS.useServerTime) {
    schedule(0);
    return;
  }

  // 서버 응답의 Date 헤더로 시차 보정
  var t0 = Date.now();
  fetch(location.origin + '/robots.txt', { method: 'HEAD', cache: 'no-store' })
    .then(function (res) {
      var serverDate = res.headers.get('Date');
      if (!serverDate) throw new Error('no date header');
      var t1 = Date.now();
      var serverNow = new Date(serverDate).getTime() + (t1 - t0) / 2;
      schedule(serverNow - t1);
    })
    .catch(function () {
      schedule(0); // 실패하면 방문자 PC 시계 기준으로 실행
    });
})();